import { NoticeEntity, NoticeEntityJson } from "@youm-front/notice/domain";

export function buildNoticeEntity(
  noticeEntityJson: NoticeEntityJson
): NoticeEntity {
  return new NoticeEntity(noticeEntityJson);
}
